'use client'

import React, { FC, ReactElement } from 'react'
import styles from './EmailWaitlist.module.css'
import classNames from 'classnames'

import ContainedInput from '@/components/contained-input'
import Button from '@/components/button'
import { EMAIL_REGEX } from '@/utils/constants'

import SuccessModal from './success-modal'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const EmailWaitlist: FC<{
	className?: string
	buttonClassname?: string
	inputClassname?: string
	buttonLabel?: string
	successTitle?: string
	tweetIntent?: string
	waitlist?: string[]
	buttonBackground?: 'white' | 'gradient-epic'
}> = (props): ReactElement => {
	const [value, setValue] = React.useState('')
	const [error, setError] = React.useState('')
	const [success, setSuccess] = React.useState(false)
	const handleChange = React.useCallback(
		(evt: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
			setValue(evt.target.value)

			if (evt.target.value !== value) {
				setError('')
			}
		},
		[value]
	)
	const handleClose = React.useCallback((evt: React.MouseEvent | React.SyntheticEvent) => {
		evt.stopPropagation()
		setSuccess(false)
	}, [])

	const handleSubmit = React.useCallback(
		async (evt: React.FormEvent<HTMLFormElement>) => {
			evt.preventDefault()
			evt.stopPropagation()
			if (!value || !EMAIL_REGEX.test(value)) {
				setSuccess(false)
				setError('Invalid Email')
				return
			}

			try {
				await fetch('/api/subscribe', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						email: value,
						list: props.waitlist
					})
				})
				setSuccess(true)
				setValue('')
				setError('')
			} catch (_e) {
				setSuccess(false)
				setError('Server Error')
			}
		},
		[props.waitlist, value]
	)

	return (
		<>
			<form
				className={classNames({ [props.className ?? '']: !!props.className }, styles.root)}
				onSubmit={handleSubmit}
				onClick={(evt) => {
					evt.stopPropagation()
					evt.preventDefault()
				}}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick((evt) => {
					evt.stopPropagation()
					evt.preventDefault()
				})}
			>
				<ContainedInput
					onClick={(evt) => {
						evt.stopPropagation()
						evt.preventDefault()
					}}
					placeholder="Enter your email"
					className={styles.inputRoot}
					inputClassName={classNames(
						{
							[props.inputClassname ?? '']: !!props.inputClassname
						},
						styles.input
					)}
					value={value}
					onChange={handleChange}
				/>
				<Button
					className={classNames(
						{ [props.buttonClassname ?? '']: !!props.buttonClassname },
						styles.button
					)}
					onClick={(evt) => {
						evt.stopPropagation()
					}}
					type="submit"
					size="small"
					background={props.buttonBackground ? props.buttonBackground : 'white'}
				>
					{error ? error : props.buttonLabel ? props.buttonLabel : 'Get launch alerts'}
				</Button>
			</form>
			<SuccessModal
				open={success}
				title={props.successTitle}
				intent={props.tweetIntent}
				onClose={handleClose}
			/>
		</>
	)
}

export default EmailWaitlist
